import React from 'react';

import theme from './FiltersAccordeon.scss';

const FiltersAccordeon = ({ filters, expandedPanels, expandPanel }) => (
  <div className={ theme.root }>
    { filters.map(({ Component, key, label }) => (
      <Component
        key={ key }
        label={ label }
        expanded={ expandedPanels.includes(key) }
        onChange={ (e, expanded) => expandPanel(expanded, key) }
      />
      ),
    ) }
  </div>
);

export default FiltersAccordeon;
